
// src/pages/Dashboard.tsx
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";

export function Dashboard() {
  const { loading, user, loggedIn } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!loading && !loggedIn) {
      navigate("/");
    }
  }, [loading, loggedIn, navigate]);

  if (loading) {
    return (
      <div className="p-6 text-sm text-muted">
        Loading your Steam profile...
      </div>
    );
  }

  if (!user) {
    return (
      <div className="p-6 text-sm text-muted">
        Could not load your Steam data.
      </div>
    );
  }

  return (
    <div className="p-6 space-y-4">
      {/* Header */}
      <div className="flex items-center gap-4">
        {user.picture && (
          <img
            src={user.picture}
            alt="Steam Avatar"
            className="w-16 h-16 rounded-full border border-border object-cover"
          />
        )}
        <div>
          <h2 className="text-2xl font-bold">{user.nickname}</h2>
          {user.country && <p className="text-sm text-muted">{user.country}</p>}
        </div>
      </div>

      {/* Content */}
      <p className="text-sm text-muted">
        Welcome to your dashboard. More Steam-linked profile features can go here.
      </p>
    </div>
  );
}
